import React from 'react';

export const Blob1 = ({ ...rest }) => (
  <svg
    {...rest}
    width="745"
    height="654"
    viewBox="0 0 745 654"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M292.298 527.298C413.579 584.178 468.575 334.629 612.025 416.79C755.475 498.95 620.246 205.062 498.965 148.183C377.684 91.3026 394.28 293.02 172.829 210.809C-48.6217 128.599 171.017 470.418 292.298 527.298Z"
      fill="#eef6f9"
    />
  </svg>
);

export const Blob2 = ({ ...rest }) => (
  <svg
    {...rest}
    width="748"
    height="579"
    viewBox="0 0 748 579"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M410.27 451.009C268.152 517.661 287.345 304.831 119.25 401.107C-48.8448 497.383 175.087 204.253 317.204 137.601C459.321 70.9484 744.612 25.1739 633.902 159.739C523.192 294.304 552.387 384.356 410.27 451.009Z"
      fill="#EFA891"
    />
  </svg>
);

export const Blob3 = ({ ...rest }) => (
  <svg
    {...rest}
    width="414"
    height="407"
    viewBox="0 0 414 407"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38.901 42.0122C38.901 42.0122 284.089 -52.5152 375.099 42.0122C462.626 132.922 375.099 364.988 375.099 364.988C375.099 364.988 129.911 459.515 38.901 364.988C-48.6262 274.078 38.901 42.0122 38.901 42.0122Z"
      fill="#E9896A"
      fillOpacity="0.74"
    />
  </svg>
);

export const Blob4 = ({ ...rest }) => (
  <svg
    {...rest}
    width="549"
    height="554"
    viewBox="0 0 549 554"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M192.671 471.552C110.172 406.269 -27.7639 175.637 169.544 193.803C366.852 211.969 362.673 87.1808 445.172 152.464C527.67 217.746 507.498 367.519 390.409 368.577C273.319 369.636 275.169 536.835 192.671 471.552Z"
      fill="#EFA891"
    />
  </svg>
);
